// Generated by ts-to-zod
import { z } from 'zod';

export const tokenPayloadSchema = z.object({
  scope: z.string().optional(),
  maxTokenLifetimeS: z.number().optional(),
  origin: z.string().optional(),
});
